module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "weiyuanhui-box"
  }, [_c('div', {
    staticClass: "tabs-box flex-start"
  }, [_c('div', {
    class: _vm.active == 0 ? 'tab-li-active' : 'tab-li',
    on: {
      "click": function($event) {
        _vm.active = 0
      }
    }
  }, [_vm._v("本月新增")]), _vm._v(" "), _c('div', {
    class: _vm.active == 1 ? 'tab-li-active' : 'tab-li',
    on: {
      "click": function($event) {
        _vm.active = 1
      }
    }
  }, [_vm._v("累计数量")])]), _vm._v(" "), _c('div', {
    staticClass: "earn-all"
  }, [_c('div', {
    staticClass: "earn-all-top"
  }, [_c('div', {
    staticClass: "earn-top-left"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("考级中心数")]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-money"
  }, [_vm._v(_vm._s(_vm.active == 1 ? _vm.row.total_examecenter : _vm.row.month_examecenter))])]), _vm._v(" "), _c('div', {
    staticClass: "earn-top-left"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("考级点数")]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-money"
  }, [_vm._v(_vm._s(_vm.active == 1 ? _vm.row.total_kaoji : _vm.row.month_kaoji))])]), _vm._v(" "), _c('div', {
    staticClass: "earn-top-left"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("当前考级人数")]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-money"
  }, [_vm._v(_vm._s(_vm.active == 1 ? _vm.row.total_kaoji_member : _vm.row.month_kaoji_member))])])]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-top"
  }, [_c('div', {
    staticClass: "earn-top-left"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("赛事场数")]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-money"
  }, [_vm._v(_vm._s(_vm.active == 1 ? _vm.row.total_sai : _vm.row.month_sai))])]), _vm._v(" "), _c('div', {
    staticClass: "earn-top-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "earn-top-left"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("赛事人数")]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-money"
  }, [_vm._v(_vm._s(_vm.active == 1 ? _vm.row.total_sai_member : _vm.row.month_sai_member))])])]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-top"
  }, [_c('div', {
    staticClass: "earn-top-left"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("培训数")]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-money"
  }, [_vm._v(_vm._s(_vm.active == 1 ? _vm.row.total_huiyi : _vm.row.month_huiyi))])]), _vm._v(" "), _c('div', {
    staticClass: "earn-top-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "earn-top-left"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("培训人数")]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-money"
  }, [_vm._v(_vm._s(_vm.active == 1 ? _vm.row.total_huiyi_member : _vm.row.month_huiyi_member))])])]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-top"
  }, [_c('div', {
    staticClass: "earn-top-left"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("俱乐部数量")]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-money"
  }, [_vm._v(_vm._s(_vm.active == 1 ? _vm.row.total_club : _vm.row.month_club))])]), _vm._v(" "), _c('div', {
    staticClass: "earn-top-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "earn-top-left"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("注册运动员数")]), _vm._v(" "), _c('div', {
    staticClass: "earn-all-money"
  }, [_vm._v(_vm._s(_vm.active == 1 ? _vm.row.total_yundongyuan : _vm.row.month_yundongyuan))])])])]), _vm._v(" "), (_vm.row.city_list.length > 0) ? _c('div', {
    staticClass: "earn-city-box"
  }, _vm._l((_vm.row.city_list), function(item, index) {
    return _c('div', {
      staticClass: "earn-city-li"
    }, [_c('div', {
      staticClass: "city-li-box"
    }, [_c('div', {
      staticClass: "city-title"
    }, [_vm._v(_vm._s(item.city))]), _vm._v(" "), _c('div', {
      staticClass: "city-member flex-between"
    }, [_c('div', {
      staticClass: "city-member-li"
    }, [_c('div', {
      staticClass: "city-member-num"
    }, [_vm._v(_vm._s(item.caipan_count))]), _vm._v(" "), _c('div', {
      staticClass: "city-member-title"
    }, [_vm._v("裁判员")])]), _vm._v(" "), _c('div', {
      staticClass: "city-member-li"
    }, [_c('div', {
      staticClass: "city-member-num"
    }, [_vm._v(_vm._s(item.jiaolian_count))]), _vm._v(" "), _c('div', {
      staticClass: "city-member-title"
    }, [_vm._v("教练员")])]), _vm._v(" "), _c('div', {
      staticClass: "city-member-li"
    }, [_c('div', {
      staticClass: "city-member-num"
    }, [_vm._v(_vm._s(item.caipan_count))]), _vm._v(" "), _c('div', {
      staticClass: "city-member-title"
    }, [_vm._v("运动员")])])])])])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f615840","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/index/WeiyuanhuiDetail.vue
// module id = 2288
// module chunks = 0